import {WithoutSummaryModel} from "../../../../common/entity/dto/plain/withoutSummary.model";
import {Moment} from "moment";

export class DocumentSignatureModel extends WithoutSummaryModel {
    name: string;
    createdAt: Moment;
    signature: string;
    email: string;
    date: Moment;
}
